const API_BASE = '/api';

export interface PreferenciaNotificacao {
  projetoId: string;
  nomeProjeto: string;
  notificacoesAtivas: boolean;
}

/**
 * Lista as preferências de notificação do cliente logado.
 * GET /api/notificacoes/preferencias
 */
export async function listarPreferencias(): Promise<PreferenciaNotificacao[]> {
  const token = localStorage.getItem('auth_token');
  const res = await fetch(`${API_BASE}/notificacoes/preferencias`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.error?.message || 'Erro ao carregar preferências de notificação.');
  }

  return res.json();
}

/**
 * Altera a preferência de notificação para um projeto específico.
 * PUT /api/notificacoes/preferencias/:projetoId
 */
export async function alterarPreferencia(
  projetoId: string,
  ativo: boolean,
): Promise<void> {
  const token = localStorage.getItem('auth_token');
  const res = await fetch(`${API_BASE}/notificacoes/preferencias/${projetoId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ ativo }),
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.error?.message || 'Erro ao alterar preferência de notificação.');
  }
}
